import React, { ReactNode } from "react";
import {
  ScanSearch,
  ScanText,
  Atom,
  Table2,
  BookText,
  Workflow,
} from "lucide-react";

interface FeatureCard {
  id: string;
  icon: ReactNode;
  title: string;
  description: string;
}

export const featureCardData: FeatureCard[] = [
  {
    id: "extraction",
    icon: (
      <ScanSearch
        className="h-10 w-10 sm:h-12 sm:w-12 text-sky-400 mb-4 sm:mb-5"
        strokeWidth={1.5}
      />
    ),
    title: "Extraction",
    description: `Our AI identifies key areas in documents across diverse layouts and formats, from books on shelves to PDFs.`,
  },
  {
    id: "ocr",
    icon: (
      <ScanText
        className="h-10 w-10 sm:h-12 sm:w-12 text-sky-400 mb-4 sm:mb-5"
        strokeWidth={1.5}
      />
    ),
    title: "Character Recognition",
    description: `State-of-the-art OCR accurately transcribes printed and handwritten text, even from hard-to-read archive notebooks.`,
  },
  {
    id: "ocsr",
    icon: (
      <Atom
        className="h-10 w-10 sm:h-12 sm:w-12 text-sky-400 mb-4 sm:mb-5"
        strokeWidth={1.5}
      />
    ),
    title: "Chemical Recognition",
    description: `Specially trained OCSR models extract molecular information from chemical diagrams across many notation styles.`,
  },
  {
    id: "table",
    icon: (
      <Table2
        className="h-10 w-10 sm:h-12 sm:w-12 text-sky-400 mb-4 sm:mb-5"
        strokeWidth={1.5}
      />
    ),
    title: "Table Structuring",
    description: `Tables are information-dense and critical to research. We detect and structure them for accurate extraction.
`,
  },
  {
    id: "structure",
    icon: (
      <BookText
        className="h-10 w-10 sm:h-12 sm:w-12 text-sky-400 mb-4 sm:mb-5"
        strokeWidth={1.5}
      />
    ),
    title: "Document Structuring",
    description: `We combine information across all pages to provide a complete view of the document.
       This ensures you keep full context of the data.`,
  },
  {
    id: "format",
    icon: (
      <Workflow
        className="h-10 w-10 sm:h-12 sm:w-12 text-sky-400 mb-4 sm:mb-5"
        strokeWidth={1.5}
      />
    ),
    title: "Format",
    description: `Structured data integrates with electronic lab notebooks,
       so you can use it within your existing research workflows.`,
  },
];
